export default "__VITE_ASSET__CBMLKqXE__"